// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_l5-1";
export var quotedThread = "_l5-0";